import { Link, NavLink, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import {
  ChartBar, Users, CreditCard, ClipboardText, FilePdf, SignOut, ArrowLeft,
} from "@phosphor-icons/react";
import { Toaster } from "@/components/ui/sonner";
import { TRENT_LOGO_URL } from "@/components/Logo";

const NAV = [
  { to: "/admin-dashboard/console", end: true, label: "Overview", icon: ChartBar, testId: "admin-nav-overview" },
  { to: "/admin-dashboard/console/users", label: "Users", icon: Users, testId: "admin-nav-users" },
  { to: "/admin-dashboard/console/customers", label: "Customers", icon: Users, testId: "admin-nav-customers" },
  { to: "/admin-dashboard/console/subscriptions", label: "Subscriptions", icon: CreditCard, testId: "admin-nav-subscriptions" },
  { to: "/admin-dashboard/console/inspections", label: "Inspections", icon: ClipboardText, testId: "admin-nav-inspections" },
  { to: "/admin-dashboard/console/reports", label: "Reports", icon: FilePdf, testId: "admin-nav-reports" },
  { to: "/admin-dashboard/console/payments", label: "Payments", icon: CreditCard, testId: "admin-nav-payments" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-[#F8FAFC] text-[#0F172A]">
      <header className="sticky top-0 z-30 bg-[#0F172A] text-white border-b border-[#1E293B]">
        <div className="mx-auto max-w-[1400px] px-4 md:px-8 h-16 flex items-center justify-between">
          <Link to="/admin-dashboard/console" className="flex items-center gap-3" data-testid="admin-brand">
            <div className="bg-white rounded-sm px-2 py-1">
              <img src={TRENT_LOGO_URL} alt="Trent" className="h-7 w-auto" />
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-white/60">
                Admin console
              </div>
            </div>
          </Link>
          <div className="flex items-center gap-3">
            <Link to="/admin-dashboard" className="text-xs uppercase tracking-wider text-white/70 hover:text-white inline-flex items-center gap-1" data-testid="admin-to-app">
              <ArrowLeft size={14} /> Back to app
            </Link>
            <div className="hidden sm:flex flex-col items-end leading-tight">
              <span className="text-sm font-semibold">{user?.name}</span>
              <span className="text-[11px] text-white/60">{user?.email} · admin</span>
            </div>
            <button onClick={logout} className="p-2 border border-white/20 rounded-md hover:bg-white/10" data-testid="admin-logout">
              <SignOut size={18} />
            </button>
          </div>
        </div>
      </header>

      <div className="mx-auto max-w-[1400px] flex">
        <aside className="hidden md:block w-56 border-r border-[#E5E7EB] min-h-[calc(100vh-64px)] bg-white">
          <nav className="p-3 space-y-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={n.testId}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium ${
                    isActive ? "bg-[#0F172A] text-white" : "text-[#0F172A] hover:bg-[#F1F5F9]"
                  }`
                }
              >
                <n.icon size={18} weight="duotone" /> {n.label}
              </NavLink>
            ))}
          </nav>
        </aside>
        <main className="flex-1 p-4 md:p-8 lg:p-10 min-w-0">
          <Outlet />
        </main>
      </div>

      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-[#E5E7EB] z-30 grid grid-cols-6 text-[9px]">
        {NAV.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            end={n.end}
            className={({ isActive }) =>
              `flex flex-col items-center py-2 ${isActive ? "text-[#0F172A] font-bold" : "text-[#475569]"}`
            }
          >
            <n.icon size={18} weight="duotone" /> {n.label}
          </NavLink>
        ))}
      </nav>

      <Toaster richColors position="top-right" />
    </div>
  );
}
